import { Action } from 'redux';

import { DraftsTelemetry } from '~src/drafts/telemetry/DraftsTelemetry';

import { EditView } from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';

export interface EditViewAction extends Action {
  view: IContentInfo;
  draftOrigin?: DraftsTelemetry.LocationOrigin;
}

export function editView(view: IContentInfo): EditViewAction {
  return {
    type: EditView,
    view
  };
}

export function editViewDraft(view: IContentInfo, draftOrigin: DraftsTelemetry.LocationOrigin): EditViewAction {
  return {
    type: EditView,
    view,
    draftOrigin
  };
}

export const isEditViewAction = isActionFactory<EditViewAction>(EditView);
